import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { useGetTransactionsQuery } from '@/features/slice/accounting/transaction';

const transactionFilterSchema = z.object({
    from: z.date().optional(),
    to: z.date().optional(),
    type: z.string().optional(),
});

export const useTransactions = () => {
    const form = useForm({
        resolver: zodResolver(transactionFilterSchema),
        defaultValues: {
            from: new Date(),
            to: new Date(),
            type: undefined,
        },
    });

    const { watch } = form;

    const fromDate = watch('from');
    const toDate = watch('to');

    const { data, isError, isLoading } = useGetTransactionsQuery({
        start_date: fromDate ? fromDate.toISOString() : undefined,
        end_date: toDate ? toDate.toISOString() : undefined,
    });

    return { data, isError, isLoading, form };
};
